import { Drawer } from "antd";
import classNames from "classnames";
import styles from "./index.module.scss";
import { Props } from "./types";

const SideDrawer = ({
  placement = "right",
  open,
  onClose,
  children,
  className = "",
  title,
  closeIcon,
  maskClosable = true,
  footer,
  headerStyle,
  width
}: Props): JSX.Element => {
  return (
    <Drawer
      className={classNames(styles.drawer, className)}
      closeIcon={closeIcon}
      footer={footer}
      maskClosable={maskClosable}
      onClose={onClose}
      open={open}
      placement={placement}
      styles={{
        header: headerStyle
      }}
      title={title}
      width={width}
    >
      {children}
    </Drawer>
  );
};

export default SideDrawer;
